import React from 'react'

import i18n from 'translations'

export const Assessment = [
  {
    name: i18n.t('assessment:viewTitle'),
    component: React.lazy(() => import('../../modules/LMS/Assessment')),
    path: '/coordinator/assessment/:assessmentId',
    guards: ['allowOnlyCoordinator', 'allowOnlyLogged'],
  },
]
